import React from 'react';
import { Row, Col, Button } from 'react-bootstrap';
import { BsCheckCircle as CheckCircle } from 'react-icons/bs';

import BayLogo from '../../BayLogo';
import { PRODUCT_LOGO_ALT } from '../../BayLogo/constants';
import BayRcDialog from '../../BayRcDialog';

export type Platform = 'client' | 'financial' | 'social';

interface BayProductsModalProps {
	showModal: boolean;
	currentlyUsing?: Platform[];
	hideModal: () => void;
	featureTransactions?: string | boolean;
}

const BayProductsModal = ({
	showModal,
	currentlyUsing,
	hideModal,
	featureTransactions,
}: BayProductsModalProps) => {
	const platformArray: Platform[] = ['client', 'financial', 'social'];

	const CardContent = ({ product }: { product: Platform }) => {
		let content = '';

		switch (product) {
			case 'client':
				content =
					'Attract buyers and sellers with modern, mobile-first websites. Then, our CRM keeps them engaged with smart, personalized correspondence.';
				break;
			case 'financial':
				content =
					'Automated financial reporting, transactions, and commissions without any mystery. Plus, hundreds of insightful reports to keep you in the loop.';
				break;
			case 'social':
				content =
					'Stay a step ahead of your competition by canvassing your market with automation and the latest marketing strategies. All relevant social platforms, all automated.';
				break;

			default:
				break;
		}

		return <>{content}</>;
	};

	const LearnMore = ({ product }: { product: Platform }) => {
		return currentlyUsing?.length && currentlyUsing?.length > 0 &&
			currentlyUsing?.includes(product) &&
			product !== 'financial' ? (
			<CheckCircle color="#009A4F" size={28} />
		) : product === 'financial' && featureTransactions === 'T' ? (
			<CheckCircle color="#009A4F" size={28} />
		) : (
			<Button
				className="text-white"
				href={`https://www.backatyou.com/${product}bay`}
				size="sm"
				target="_blank"
				variant="primary"
			>
				Learn More
			</Button>
		);
	};

	return (
		<BayRcDialog
			closeButton
			hideFooter
			maxHeight="auto"
			show={showModal}
			size="lg"
			title="Browse All Back At You Products"
			onHideFunc={hideModal}
		>
			<Row className="d-flex align-content-center align-items-center gy-4">
				<Col xs={12}>
					<p className="text-500">
						Interested in learning more about the other great things we can do
						together? Click 'Learn More' on any product below to get a demo!
					</p>
				</Col>
				{platformArray.map((item, index) => {
					return (
						<Col key={index} sm={6} xs={12}>
							<div className="card shadow-sm bg-light rounded">
								<div className="card-body p-4 py-3">
									<div className="card-title h5 d-flex align-items-center justify-content-between">
										<BayLogo
											alt={PRODUCT_LOGO_ALT[item]}
											logoStyle="full"
											platform={item}
											size="21px"
										/>
										<LearnMore product={item} />
									</div>
									<p className="card-text">
										<CardContent product={item} />
									</p>
								</div>
							</div>
						</Col>
					);
				})}
			</Row>
		</BayRcDialog>
	);
};

export default BayProductsModal;
